import { defineMessages } from 'react-intl'

const messages = defineMessages({
  insuranceTitle: {
    id: 'VlhgUt+O+3',
    defaultMessage: 'Want to add travel insurance?',
    description: 'Checkout section title for travel insurance upsell',
  },
  travelProtectionTitle: {
    id: 'XJZo4ww2pI',
    defaultMessage: 'Want to add travel protection?',
    description: 'Checkout section title for travel protection upsell',
  },
})

export const INSURANCE_TITLE_DESCRIPTOR = messages.insuranceTitle
export const TRAVEL_PROTECTION_TITLE_DESCRIPTOR = messages.travelProtectionTitle
